export default __webpack_public_path__ + "list-minus.76d10475462d4f59.svg";